import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

export const WITHDRAW_OUTBOUND_SUBSCRIPTION = gql(`
  mutation WITHDRAW_OUTBOUND_SUBSCRIPTION($subscriptionId: ID!) {
    subscriptionCancelOutbound(subscriptionId: $subscriptionId) {
      ... AppSubscriptionCancel
    }
  }
`);

export const useWithdrawOutboundSubscription = () =>
  useMutation(WITHDRAW_OUTBOUND_SUBSCRIPTION);
